const PURCHASE_METHODS = {
    CASH: 0x1,
    FINANCE: 0x100,
    FINANCE_WITH_BALLOON: 0x300,
    LEASE: 0x1000,
    SINGLE_PAYMENT_LEASE: 0x3000,
};

export default PURCHASE_METHODS;



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethodsValues.js